<template>
    <v-touch
        @swiperight="swiperright"
        class="wrapper"
    >
        <div class="previousQuery">
            <van-nav-bar
                title="往期查询"
                left-text="供应方量"
                left-arrow
                @click-left="onClickLeft"
            >
                <van-icon
                    class="iconfont iconshaixuan"
                    slot="right"
                    @click="showPopup('screen')"
                ></van-icon>
            </van-nav-bar>
            <section>
                <div
                    class="chart"
                    id="myChart"
                ></div>
                <ul>
                    <li>
                        <div class="head">
                            <p class="van_left iconfont iconriqi1">
                                1月份
                            </p>
                            <span class="van_right">
                                月结算率:
                                <i>50%</i>
                            </span>
                        </div>
                        <van-divider dashed :style="{ borderColor: '#D7D7D7'}"></van-divider>
                        <table>
                            <tr>
                                <th>月生产值(万元)</th>
                                <th>月结算值(万元)</th>
                                <th>月生产方量(m³)</th>
                                <th>月结算方量(m³)</th>
                            </tr>
                            <tr>
                                <td>32000</td>
                                <td>32000</td>
                                <td>32000</td>
                                <td>32000</td>
                            </tr>
                        </table>
                    </li>
                </ul>
            </section>
            <van-popup
                class="sideslip"
                v-model="popupShow"
                position="right"
                :style="{ width: '80%',height: '100%' }"
            >
                <div class="screen">
                    <van-nav-bar
                        title="筛选"
                        right-text="取消"
                        @click-right="onClickRight"
                    >
                    </van-nav-bar>
                    <section>
                        <dl>
                            <dt>月份</dt>
                            <dd>
                                <p>近3个月</p>
                                <p>近6个月</p>
                                <p>近9个月</p>
                                <p>近12个月</p>
                            </dd>
                        </dl>
                        <dl>
                            <dt>年份</dt>
                            <dd>
                                <p>2019年</p>
                                <p>2018年</p>
                                <p>2017年</p>
                                <p>2016年</p>
                                <p>2015年</p>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="confirmSelect">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 往期查询
    name: 'previous-query',
    components: {},
    props: {},
    data() {
        return {
            // 筛选侧滑菜单状态
            popupShow: false,
        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() {
        this.initCharts();
    },
    destroyed() { },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 展开筛选菜单
        showPopup() {
            this.popupShow = true;
        },
        // 关闭筛选菜单
        onClickRight() {
            this.popupShow = false;
        },
        // 确认筛选
        confirmSelect() {
            this.popupShow = true;
        },
        // 重置筛选条件
        resetSelect() {
        },
        // 基于准备好的dom，初始化echarts实例
        initCharts() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('myChart'));
            // 指定图表的配置项和数据
            const option = {
                legend: {
                    y: 15,
                    data: ['月生产值', '结算产值'],
                },
                color: ['#289df5', '#fbc01b', '#ff5050'],
                grid: {
                    left: 15,
                    right: 15,
                    bottom: 15,
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '12',
                            color: '#979EA7',
                        },
                    },
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#D7D7D7',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#a3a4b2',
                        },
                    },
                    name: '单位(亿元)',
                    nameTextStyle: {
                        color: '#979EA7',
                    },
                    nameGap: 20,
                },
                series: [{
                    name: '月生产值',
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#FD6F64' },
                                { offset: 1, color: '#fff' },
                            ]),
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#FD6F64',
                            lineStyle: {
                                color: '#FD6F64',
                            },
                            label: {
                                show: true,
                            },
                        },
                    },
                    data: [310, 212, 221, 154, 260, 430, 310, 110, 120, 210, 124, 60],
                }, {
                    name: '结算产值',
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        normal: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#51A6FE' },
                                { offset: 1, color: '#fff' },
                            ]),
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: '#51A6FE',
                            lineStyle: {
                                color: '#51A6FE',
                            },
                            label: {
                                show: true,
                            },
                        },
                    },
                    data: [151, 282, 151, 120, 120, 80, 130, 182, 234, 191, 90, 30],
                }],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="stylus" scoped>
.previousQuery
    height 100%
    section
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        background #F0F0F0
        .chart
            height 242rpx
            background #fff
        ul
            padding 15rpx
            li
                border-radius 4rpx
                background #fff
                overflow hidden
                .head
                    overflow hidden
                    height 44rpx
                    line-height 44rpx
                    padding 0 15rpx
                    p
                        font-size 16rpx
                        color #061F3E
                        &:before
                            font-size 20rpx
                            color #3495FB
                    span
                        font-size 12rpx
                        color #979EA7
                        i
                            color #21BDCC
                .van-divider
                    margin 0
                table
                    margin 15rpx
                    border-collapse collapse
                    th,td
                        text-align center
                        line-height 25rpx
                        border 1px solid #F0F0F0
                    th
                        font-size 10rpx
                        color #979EA7
                    td
                        font-size 14rpx
                        color #3495FB
    .screen
        height 100%
        section
            background none
            height calc(100% - 45rpx)
            dt
                font-size 14rpx
            dd
                .van-cell-group
                    &:after
                        border 1px solid #f0f0f0
                    .van-cell
                        padding 5rpx 16rpx
                        margin-bottom 15rpx
                i
                    font-size 12rpx
                    color #ccc
</style>